(function () {
    'use strict';

    class SubscriptionCreditCardFormController extends Controllers.BaseControllerES6 {

        // @ngInject
        constructor($scope, $injector, Recurly, $translate, UIUtils, UsersManager, $, GoogleTagManagerService) {
            super($scope, $injector);
            this.__objectType = 'SubscriptionCreditCardFormController';

            this.Recurly = Recurly;
            this.$scope = $scope;
            this.$translate = $translate;
            this.UIUtils = UIUtils;
            this.UsersManager = UsersManager;
            this.$ = $;
            this.GoogleTagManagerService = GoogleTagManagerService;
        }

        $onInit() {
            this.card = {
                firstName: '',
                lastName: '',
                postalCode: ''
            };

            this.cardMonthLengthWas = 0;
            this.creditCardType = 'default';
            this.isFormSubmitted = false;
            this.user = this.UsersManager.getCurrUser();
            this.attachCreditCardFields();
        }

        $onChanges(changes) {
            if (changes.submitTriggered.currentValue) {
                this.addCardForm.$setSubmitted();
                this.resetSubmitButton();
                this.generateRecurlyToken();
                this.isFormSubmitted = true;
            }
        }

        attachFieldEvents() {

            // focus
            this.cardNumberElement.on("focus", (element) => {
                this.$(element._container.parentNode).addClass("hb-focus-element");
            });
            this.cardMonthElement.on("focus", (element) => {
                this.$(element._container.parentNode).addClass("hb-focus-element");
            });
            this.cardYearElement.on("focus", (element) => {
                this.$(element._container.parentNode).addClass("hb-focus-element");
            });
            this.cardCvvElement.on("focus", (element) => {
                this.$(element._container.parentNode).addClass("hb-focus-element");
            });


            // blur
            this.cardNumberElement.on("blur", (element) => {
                this.$(element._container.parentNode).removeClass("hb-focus-element");
            });
            this.cardMonthElement.on("blur", (element) => {
                this.$(element._container.parentNode).removeClass("hb-focus-element");
            });
            this.cardYearElement.on("blur", (element) => {
                this.$(element._container.parentNode).removeClass("hb-focus-element");
            });
            this.cardCvvElement.on("blur", (element) => {
                this.$(element._container.parentNode).removeClass("hb-focus-element");
            });

            // change
            this.cardNumberElement.on("change", event => {
                if (event.empty) {
                    this.$(this.cardNumberElement._container.parentNode).removeClass("hb-dirty-element");
                } else {
                    this.card_number_error = null;
                    this.$(this.cardNumberElement._container.parentNode).addClass("hb-dirty-element");
                }

                switch (event.brand) {
                    case 'visa':
                    case 'master':
                    case 'american_express':
                    case 'jcb':
                    case 'discover':
                    case 'diners_club':
                        this.creditCardType = event.brand;
                        break;
                    default:
                        this.creditCardType = 'default';
                        break;
                }

                this.$scope.$applyAsync();
            });

            this.cardMonthElement.on("change", event => {
                if (event.empty) {
                    this.$(this.cardMonthElement._container.parentNode).removeClass("hb-dirty-element");
                } else {
                    if (event.length === 2 && this.cardMonthLengthWas !== 2) {
                        this.cardYearElement.focus();
                    }
                    this.card_month_error = null;
                    this.$(this.cardMonthElement._container.parentNode).addClass("hb-dirty-element");
                }
                this.cardMonthLengthWas = event.length;
                this.$scope.$applyAsync();
            });

            this.cardYearElement.on("change", event => {
                if (event.empty) {
                    this.$(this.cardYearElement._container.parentNode).removeClass("hb-dirty-element");
                } else {
                    this.card_year_error = null;
                    this.$(this.cardYearElement._container.parentNode).addClass("hb-dirty-element");
                }

                this.$scope.$applyAsync();
            });

            this.cardCvvElement.on("change", event => {
                if (event.empty) {
                    this.$(this.cardCvvElement._container.parentNode).removeClass("hb-dirty-element");
                } else {
                    this.card_cvv_error = null;
                    this.$(this.cardCvvElement._container.parentNode).addClass("hb-dirty-element");
                }

                this.$scope.$applyAsync();
            });


        }

        attachCreditCardFields() {
            this.Recurly.then(this._attachCreditCardFieldsLogic.bind(this));
        }

        _attachCreditCardFieldsLogic(recurlySdk) {
            const cardInputStyle = {
                inputType: 'text',
                style: {
                    fontSize: '13px',
                    fontFamily: 'Montserrat, sans-serif',
                    fontWeight: '400',
                    fontColor: 'rgba(0, 0, 0, 0.75)',
                    padding: '2px 0 1px',
                    invalid: {
                        color: '#FF6161'
                    }
                }
            };

            this.elements = recurlySdk.Elements();

            this.cardNumberElement = this.elements.CardNumberElement(cardInputStyle);
            this.cardMonthElement = this.elements.CardMonthElement(cardInputStyle);
            this.cardYearElement = this.elements.CardYearElement(cardInputStyle);
            this.cardCvvElement = this.elements.CardCvvElement(cardInputStyle);

            this.cardNumberElement.attach('#card-number');
            this.cardMonthElement.attach('#card-month');
            this.cardYearElement.attach('#card-year');
            this.cardCvvElement.attach('#card-cvv');

            this.attachFieldEvents();
        }

        isValidCardFirstName() {
            if (this.isFormSubmitted && !this.card.firstName) {
                this.card_first_name_error = this.$translate.instant('FILE.PAYMENT.ADD_NEW_CARD.ERRORS._REQUIRED_FIELD_');
                return false;
            } else {
                this.card_first_name_error = null;
                return true;
            }
        }

        isValidPostalCode() {
            if (this.isFormSubmitted && !this.card.postalCode) {
                this.postal_code_error = this.$translate.instant('FILE.PAYMENT.ADD_NEW_CARD.ERRORS._REQUIRED_FIELD_');
                return false;
            } else {
                this.postal_code_error = null;
                return true;
            }

        }

        isValidCardLastName() {
            if (this.isFormSubmitted && !this.card.lastName) {
                this.card_last_name_error = this.$translate.instant('FILE.PAYMENT.ADD_NEW_CARD.ERRORS._REQUIRED_FIELD_');
                return false;
            } else {
                this.card_last_name_error = null;
                return true;
            }
        }

        isValidCardNumber(isEmpty) {
            if (this.isFormSubmitted && isEmpty) {
                this.card_number_error = this.$translate.instant('FILE.PAYMENT.ADD_NEW_CARD.ERRORS._REQUIRED_FIELD_');
                return false;
            } else {
                this.card_number_error = null;
                return true;
            }
        }

        isValidCardCvv(isEmpty) {
            if (this.isFormSubmitted && isEmpty) {
                this.card_cvv_error = this.$translate.instant('FILE.PAYMENT.ADD_NEW_CARD.ERRORS._REQUIRED_FIELD_');
                return false;
            } else {
                this.card_cvv_error = null;
                return true;
            }
        }

        isValidCardMonth(isEmpty) {
            if (this.isFormSubmitted && isEmpty) {
                this.card_month_error = this.$translate.instant('FILE.PAYMENT.ADD_NEW_CARD.ERRORS._REQUIRED_FIELD_');
                return false;
            } else {
                this.card_month_error = null;
                return true;
            }
        }

        isValidCardYear(isEmpty) {
            if (this.isFormSubmitted && isEmpty) {
                this.card_year_error = this.$translate.instant('FILE.PAYMENT.ADD_NEW_CARD.ERRORS._REQUIRED_FIELD_');
                return false;
            } else {
                this.card_year_error = null;
                return true;
            }
        }

        isValidForm() {
            const _isValidFirstName = this.isValidCardFirstName();
            const _isValidLastName = this.isValidCardLastName();
            const _isValidPostalCode = this.isValidPostalCode();

            return _isValidFirstName && _isValidLastName && _isValidPostalCode;
        }

        clearErrors() {
            this.card_number_error = '';
            this.card_cvv_error = '';
            this.card_month_error = '';
            this.card_year_error = '';
            this.card_first_name_error = '';
            this.card_last_name_error = '';
            this.postal_code_error = '';
        }

        handleRecurlyErros(err) {
            // handle error using err.code and err.fields
            // Error object example:
            // {
            //     name: "validation"
            //     code: "validation"
            //     message: "There was an error validating your request."
            //     fields: ["number", "month", "year", "first_name", "last_name", "postal_code"]
            // }

            if (err) {
                err.fields.forEach(field => {
                    switch (field) {
                        case 'number':
                            this.card_number_error = this.$translate.instant('FILE.PAYMENT.ADD_NEW_CARD.ERRORS._INVALID_CARD_NUMBER_');
                            break;
                        case 'month':
                            this.card_month_error = this.$translate.instant('FILE.PAYMENT.ADD_NEW_CARD.ERRORS._INVALID_');
                            break;
                        case 'year':
                            this.card_year_error = this.$translate.instant('FILE.PAYMENT.ADD_NEW_CARD.ERRORS._INVALID_');
                            break;
                        case 'first_name':
                            this.card_first_name_error = this.$translate.instant('FILE.PAYMENT.ADD_NEW_CARD.ERRORS._REQUIRED_FIELD_');
                            break;
                        case 'last_name':
                            this.card_last_name_error = this.$translate.instant('FILE.PAYMENT.ADD_NEW_CARD.ERRORS._REQUIRED_FIELD_');
                            break;
                        case 'postal_code':
                            this.postal_code_error = this.$translate.instant('FILE.PAYMENT.ADD_NEW_CARD.ERRORS._REQUIRED_FIELD_');
                            break;
                        case 'cvv':
                            this.card_cvv_error = this.$translate.instant('FILE.PAYMENT.ADD_NEW_CARD.ERRORS._INVALID_');
                            break;
                        default:
                            break;
                    }
                });
            }

            if (this._isCvvEmpty()) {
                this.card_cvv_error = this.$translate.instant('FILE.PAYMENT.ADD_NEW_CARD.ERRORS._REQUIRED_FIELD_');
            }

            if (this._isPostalCodeEmpty()) {
                this.postal_code_error = this.$translate.instant('FILE.PAYMENT.ADD_NEW_CARD.ERRORS._REQUIRED_FIELD_');
            }

            this.$scope.$applyAsync();
        }

        _isCvvEmpty() {
            return this.cardCvvElement.state.empty;
        }

        _isPostalCodeEmpty() {
            return this.addCardForm.postal_code.$invalid;
        }

        generateRecurlyToken() {
            this.Recurly.then(this._generateRecurlyTokenLogic.bind(this));
        }

        _generateRecurlyTokenLogic(recurlySdk) {
            const elements = this.elements;
            const form = document.querySelector('#subscription-checkout-form');
            recurlySdk.token(elements, form, (err, token) => {
                if (err || this._isCvvEmpty() || this._isPostalCodeEmpty()) {
                    this.handleRecurlyErros(err);
                } else {
                    // recurly.js has filled in the 'token' field, so now we can submit the
                    // form to your server
                    // form.submit();
                    this.GoogleTagManagerService.trackEvent('paymentSubmission');
                    if (this.onSubmit && angular.isFunction(this.onSubmit)) {
                        this.onSubmit({token: token});
                    }
                }
            });
        }
    }

    Components.SubscriptionCreditCardForm = {
        controller: SubscriptionCreditCardFormController,
        bindings: {
            submitTriggered: '<',
            onSubmit: '&',
            resetSubmitButton: '&'
        },
        name: 'SubscriptionCreditCardForm',
        templateUrl: 'angular/app/modules/core/features/settings/company/subscription/subscription_credit_card_form.html',
    };
}());
